import { IAccountsDomain, Pangolin } from 'services/accounts/types';
import { ResultKind } from 'services/base/types';
import { RebootPangolinResult, UnclaimPangolinResult, reboot, unclaim } from 'services/accounts/pangolin_service';

import { BusyStore } from 'ui/base/button';
import { PasswordStore } from 'ui/base/input';
import { action, observable, runInAction } from 'mobx';
import Messages from './unlink_pangolin_messages';
import { ModalStore } from 'ui/base/modal/modal_store';

export class UnlinkPangolinStore {
  readonly pangolin: Pangolin;
  readonly passwordModal: ModalStore;
  readonly password: PasswordStore;

  @observable.ref
  rebootError: string | undefined;

  @observable.ref
  idError: string | undefined;

  @observable.ref
  passwordError: string | undefined;

  @observable.ref
  updateUpgradeError: string | undefined;

  @observable.ref
  updateRestoreError: string | undefined;

  @observable.ref
  planFirewallSubscriptionError: string | undefined;

  @observable.ref
  busyReboot: BusyStore;

  @observable.ref
  busyUnlink: BusyStore;

  constructor(pangolin: Pangolin) {
    this.pangolin = pangolin;
    this.passwordModal = new ModalStore(false);
    this.password = new PasswordStore('');
    this.rebootError = undefined;
    this.idError = undefined;
    this.passwordError = undefined;
    this.updateUpgradeError = undefined;
    this.updateRestoreError = undefined;
    this.planFirewallSubscriptionError = undefined;
    this.busyReboot = new BusyStore();
    this.busyUnlink = new BusyStore();
  }

  @action.bound
  async handleReboot(): Promise<RebootPangolinResult> {
    this.rebootError = undefined;
    const response = await reboot({
      id: this.pangolin.id,
    });
    return runInAction(() => {
      if (response.kind === ResultKind.SYSTEM_ERROR) {
        this.rebootError = Messages.rebootError();
      }
      return response;
    });
  }

  @action.bound
  async handleUnlink(domain: IAccountsDomain): Promise<UnclaimPangolinResult> {
    this.idError = undefined;
    this.passwordError = undefined;
    this.updateUpgradeError = undefined;
    this.updateRestoreError = undefined;
    this.planFirewallSubscriptionError = undefined;
    const result = await unclaim({
      domain,
      pangolin: this.pangolin,
      password: this.password.value,
    });
    return runInAction(() => {
      if (result.kind === ResultKind.USER_ERROR) {
        this.idError = result.idError;
        this.passwordError = result.passwordError;
        this.updateUpgradeError = result.updateUpgradeError;
        this.updateRestoreError = result.updateRestoreError;
        this.planFirewallSubscriptionError = result.planFirewallSubscriptionError;
      }
      return result;
    });
  }
}
